import React from 'react';
import DynamicLegalPage from '../components/DynamicLegalPage';

const PrivacyPage: React.FC = () => {
  return <DynamicLegalPage pageType="privacy" />;
};

export default PrivacyPage; 